import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { I18nPropvider } from './lang';
import { routes } from './routes';
import './sass/assets/index.scss';
import EnvService from './services/EnvService';
import HelperService from './services/HelperService';
import TelegramWebApiService from './services/TelegramWebApiService';
import store from './store';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const runtimeConfig = window.__APP_CONFIG__ || {};

EnvService?.Init();
TelegramWebApiService?.Init();
const initPromise = HelperService.Init();

serviceWorkerRegistration.register();

const container = document.getElementById('root');
const root = createRoot(container);
const router = createBrowserRouter(routes);

if (process.env.NODE_ENV === 'production') {
	posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
		api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
		// advanced_disable_decide: true,
		capture_pageview: true,
		autocapture: false,
		debug: false,
	});
}
initPromise.then(() => {
	root.render(
		<React.StrictMode>
			<PostHogProvider client={posthog}>
				<Provider store={store}>
					<I18nPropvider>
						<RouterProvider router={router} />
					</I18nPropvider>
				</Provider>
			</PostHogProvider>
		</React.StrictMode>
	);
});

export { router };
